
// src/reducers/user-reducer.js
import { mergeArray, deleteArray } from '../helpers/store'

import {
  FETCH_NOTIFICATION_SETTINGS,
  FETCH_NOTIFICATION_SETTINGS_REQUESTED,
  FETCH_NOTIFICATION_SETTINGS_COMPLETED,
  FETCH_NOTIFICATION_SETTINGS_FAILED,
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS_REQUESTED,
  UPDATE_NOTIFICATION_SETTINGS_COMPLETED,
  UPDATE_NOTIFICATION_SETTINGS_FAILED,
  UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS,
  UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED,
  UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED,
  UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED,
  UPDATE_SCHEDULE_TYPE,
  UPDATE_SCHEDULE_TYPE_REQUESTED,
  UPDATE_SCHEDULE_TYPE_COMPLETED,
  UPDATE_SCHEDULE_TYPE_FAILED,
  UPDATE_SCHEDULE_ACTIVE,
  UPDATE_SCHEDULE_ACTIVE_REQUESTED,
  UPDATE_SCHEDULE_ACTIVE_COMPLETED,
  UPDATE_SCHEDULE_ACTIVE_FAILED,
  UPDATE_DAY_SCHEDULE,
  UPDATE_DAY_SCHEDULE_REQUESTED,
  UPDATE_DAY_SCHEDULE_COMPLETED,
  UPDATE_DAY_SCHEDULE_FAILED,
  UPDATE_CUSTOM_SCHEDULE,
  UPDATE_CUSTOM_SCHEDULE_REQUESTED,
  UPDATE_CUSTOM_SCHEDULE_COMPLETED,
  UPDATE_CUSTOM_SCHEDULE_FAILED,
  FETCH_CURRENT_USER,
  FETCH_CURRENT_USER_REQUESTED,
  FETCH_CURRENT_USER_COMPLETED,
  FETCH_CURRENT_USER_FAILED,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_REQUESTED,
  UPDATE_USER_PROFILE_COMPLETED,
  UPDATE_USER_PROFILE_FAILED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_REQUESTED,
  UPDATE_PASSWORD_COMPLETED,
  UPDATE_PASSWORD_FAILED,
  UPDATE_EMAIL,
  UPDATE_EMAIL_REQUESTED,
  UPDATE_EMAIL_COMPLETED,
  UPDATE_EMAIL_FAILED,
  REQUEST_CONFIRMATION_MAIL,
  REQUEST_CONFIRMATION_MAIL_REQUESTED,
  REQUEST_CONFIRMATION_MAIL_COMPLETED,
  REQUEST_CONFIRMATION_MAIL_FAILED,
  SAVE_ANNOUNCE_LAST_SEEN_TIME,
  SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED,
  SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED,
  SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED,
  UPDATE_USER_MENU_ITEMS_REQUESTED,
  UPDATE_USER_MENU_ITEMS_COMPLETED,
  UPDATE_USER_MENU_ITEMS_FAILED,
} from '../actions/user'

import {
  CLEAR_LOGIN_STATUS,
  LOGOUT_COMPLETED,
} from '../actions/sessions'

import isEqual from 'lodash/isEqual'
import moment from 'moment'

const initialState = {
  isFetching: false,
  isFailed: false,
  isNotificationUpdating: false,
  isNotificationUpdateFailed: false,
  isProfileUpdating: false,
  isProfileUpdateFailed: false,
  isPasswordUpdating: false,
  isPasswordUpdateFailed: false,
  isEmailUpdating: false,
  isEmailUpdateFailed: false,
  isConfirmationRequesting: false,
  isConfirmationRequestFailed: false,
  current: undefined,
  notificationSettings: undefined,
  firstLogin: false,
}

export default function userReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_NOTIFICATION_SETTINGS_REQUESTED:
  case FETCH_CURRENT_USER_REQUESTED:
  case SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFailed: false,
    })

  case UPDATE_NOTIFICATION_SETTINGS_REQUESTED:
  case UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED:
  case UPDATE_SCHEDULE_TYPE_REQUESTED:
  case UPDATE_SCHEDULE_ACTIVE_REQUESTED:
  case UPDATE_DAY_SCHEDULE_REQUESTED:
  case UPDATE_CUSTOM_SCHEDULE_REQUESTED:
    return Object.assign({}, state, {
      isNotificationUpdating: true,
      isNotificationUpdateFailed: false,
    })

  case UPDATE_USER_PROFILE_REQUESTED:
  case UPDATE_USER_MENU_ITEMS_REQUESTED:
    return Object.assign({}, state, {
      isProfileUpdating: true,
      isProfileUpdateFailed: false,
    })

  case UPDATE_PASSWORD_REQUESTED:
    return Object.assign({}, state, {
      isPasswordUpdating: true,
      isPasswordUpdateFailed: false,
    })

  case REQUEST_CONFIRMATION_MAIL_REQUESTED:
    return Object.assign({}, state, {
      isConfirmationRequesting: true,
      isConfirmationRequestFailed: false,
    })

  case UPDATE_EMAIL_REQUESTED:
    return Object.assign({}, state, {
      isEmailUpdating: true,
      isEmailUpdateFailed: false,
    })

  case FETCH_NOTIFICATION_SETTINGS_FAILED:
  case FETCH_CURRENT_USER_FAILED:
  case SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFailed: true,
    })

  case UPDATE_NOTIFICATION_SETTINGS_FAILED:
  case UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED:
  case UPDATE_SCHEDULE_TYPE_FAILED:  
  case UPDATE_SCHEDULE_ACTIVE_FAILED:  
  case UPDATE_DAY_SCHEDULE_FAILED:  
  case UPDATE_CUSTOM_SCHEDULE_FAILED:  
    return Object.assign({}, state, {
      isNotificationUpdating: false,
      isNotificationUpdateFailed: true,
    })

  case UPDATE_USER_PROFILE_FAILED:
  case UPDATE_USER_MENU_ITEMS_FAILED:
    return Object.assign({}, state, {
      isProfileUpdating: false,
      isProfileUpdateFailed: true,
    })

  case UPDATE_PASSWORD_FAILED:
    return Object.assign({}, state, {
      isPasswordUpdating: false,
      isPasswordUpdateFailed: true,
    })

  case REQUEST_CONFIRMATION_MAIL_FAILED:
    return Object.assign({}, state, {
      isConfirmationRequesting: false,
      isConfirmationRequestFailed: true,
    })

  case UPDATE_EMAIL_FAILED:
    return Object.assign({}, state, {
      isEmailUpdating: false,
      isEmailUpdateFailed: true,
    })

  case FETCH_NOTIFICATION_SETTINGS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFailed: false,
      notificationSettings: action.results,
    })

  case UPDATE_NOTIFICATION_SETTINGS_COMPLETED:
  case UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED:
  case UPDATE_SCHEDULE_TYPE_COMPLETED:
  case UPDATE_SCHEDULE_ACTIVE_COMPLETED:
  case UPDATE_DAY_SCHEDULE_COMPLETED:
  case UPDATE_CUSTOM_SCHEDULE_COMPLETED:
    return Object.assign({}, state, {
      isNotificationUpdating: false,
      isNotificationUpdateFailed: false,
      notificationSettings: action.results,
    })

  case FETCH_CURRENT_USER_COMPLETED:
    let current = state.current
    if (!isEqual(current, action.results))
      current = action.results

    return Object.assign({}, state, {
      isFailed: false,
      isFetching: false,
      current,
      firstLogin: action.results.sign_in_count <= 1 && moment(action.results.created_at).isAfter(moment().add(-10, 'days')),
    })

  case SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED:
    return Object.assign({}, state, {
      isFailed: false,
      isFetching: false,
      current: action.results
    })

  case LOGOUT_COMPLETED:
    return Object.assign({}, initialState)

  case UPDATE_USER_PROFILE_COMPLETED:
  case UPDATE_USER_MENU_ITEMS_COMPLETED:
    const results = Object.assign({}, action.results, {
      icon_image: {
        url: action.results.icon_image.url + `?refresh=${Math.random()}`,
        thumb_url: action.results.icon_image.thumb_url + `?refresh=${Math.random()}`,
      }
    })
    return Object.assign({}, state, {
      isProfileUpdating: false,
      isProfileUpdateFailed: false,
      current: results,
      firstLogin: action.results.sign_in_count <= 1 && moment(action.results.created_at).isAfter(moment().add(-10, 'days')),
    })

  case UPDATE_PASSWORD_COMPLETED:
    return Object.assign({}, state, {
      isPasswordUpdating: false,
      isPasswordUpdateFailed: false,
    })

  case UPDATE_EMAIL_COMPLETED:
    return Object.assign({}, state, {
      isEmailUpdating: false,
      isEmailUpdateFailed: false,
      current: action.results,
    })

  case REQUEST_CONFIRMATION_MAIL_COMPLETED:
    return Object.assign({}, state, {
      isConfirmationRequesting: false,
      isConfirmationRequestFailed: false,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js